import React from "react";
import CustomDropdown from "../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";

import moment from "moment";

const IntervalSelector = (props) => {
    let week_disabled = false,
        hour_disabled = false,
        day_disabled = false,
        month_disabled = false,
        year_disabled = false;
    if (props.appliedFilter && (props.appliedFilter.duration == "24HRS" || props.appliedFilter.duration == 1)) {
        // day_disabled = true;
        // week_disabled = true;
        // month_disabled = true;
        // year_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "7") {
        // week_disabled = true;
        // month_disabled = true;
        // year_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "30") {
        hour_disabled = true;
        // month_disabled = true;
        // year_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "lastmonth") {
        hour_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "lastquarter") {
        hour_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "last2quarter") {
        hour_disabled = true;
    } else if (props.appliedFilter && props.appliedFilter.duration == "custom") {
        let diff = moment(props.appliedFilter.end_date).diff(props.appliedFilter.start_date, "days", true);
        if (diff <= 1) {
            // day_disabled = true;
            // week_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (diff > 1 && diff <= 29) {
            // week_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (diff > 29 && diff <= 89) {
            hour_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (diff > 89 && diff <= 366) {
            hour_disabled = true;
            day_disabled = true;
        }
    }

    const aggsIntervalOptions = [
        { label: "Daily", value: "daily", disabled: day_disabled },
        { label: "Weekly", value: "weekly", disabled: week_disabled },
        { label: "Monthly", value: "monthly", disabled: month_disabled },
        { label: "Yearly", value: "yearly", disabled: year_disabled },
    ];
    const getAggsVal = () => {
        let aggs_val;
        if (props.aggs_val?.slice(-2) === "ly") return props.aggs_val;
        else props.aggs_val === "day" || props.aggs_val === "hour" || props.aggs_val === undefined ? (aggs_val = "daily") : (aggs_val = props.aggs_val + "ly");
        return aggs_val;
    };

    return (
        <CustomDropdown
            className="interval-selector"
            name="Select Interval"
            options={aggsIntervalOptions}
            value={getAggsVal()}
            onChange={props.handleIntervalChange}
        />
    );
};

export default IntervalSelector;
